module.exports = __webpack_public_path__ + "img/es_ESs.0851a726.png";